import React, { useState } from "react";
import { Box, Paper, Typography, TextField, Button } from "@mui/material";
import { toast } from "react-toastify";
import API from "../utils/api";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const theme = useTheme();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Simple email validation regex
  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Frontend validation before hitting API
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await API.post("/auth/password_reset/", { email });

      toast.success("Reset link sent! Check your email.");

      // Redirect after success
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      console.error("Password reset error:", err);
      toast.error("Failed to send reset email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        px: 2,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: { xs: 3, sm: 5 },
          width: "100%",
          maxWidth: 420,
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" color="primary" fontWeight={700} mb={1}>
          Forgot Password
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Enter your email to receive a password reset link.
        </Typography>

        {error && (
          <Typography
            variant="body2"
            color="error"
            sx={{ mb: 2, whiteSpace: "pre-line" }}
          >
            {error}
          </Typography>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError(""); // Clear error as user types
            }}
            required
            sx={{ mb: 2 }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={loading || !validateEmail(email)}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
